import { apiRoutes } from 'config/apiRoutes'
import { useQuery } from 'libs/query'
import type { SaleRes } from 'features/sales'
import { useAxiosPrivate } from 'shared/hooks'
import { useParams } from 'libs/router'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'

export const useFetchSaleQuery = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const { auth } = useContext(AuthContext)

	const { data: saleData } = useQuery<SaleRes>({
		queryKey: queryKeys.sales.detail(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.sale(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		saleData
	}
}
